import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { getRequest } from "api";

const { Option } = Select;

function SelectWithEndpoint({ endpoint, ...props }) {
  const [dtSrc, setDtSrc] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getRequest(endpoint);
        const prepareData = [];

        res.data.Data.forEach((item) => {
          prepareData.push({ val: item.Val, txt: item.Name });
        });

        setDtSrc(prepareData);
      } catch (error) {}
    };

    fetchData();
  }, [endpoint]);

  return (
    <Select style={{ width: 188, marginBottom: 8, display: "block" }} {...props}>
      {dtSrc.map((data) => (
        <Option key={data.val} value={data.val}>{`${data.txt}`}</Option>
      ))}
    </Select>
  );
}

export default SelectWithEndpoint;
